import { PhoneticType } from '../constants';
import { IPhoneticSystem } from '../types/IPhoneticSystem';
import JyutpingSystem from './JyutpingSystem';
import YaleSystem from './YaleSystem';

const systems: { [name: string]: IPhoneticSystem } = {
    [PhoneticType.Jyutping]: new JyutpingSystem(),
    [PhoneticType.Yale]: new YaleSystem(),
};

const getPhoneticSystem = (name: string): IPhoneticSystem => {
    if (!Object.prototype.hasOwnProperty.call(systems, name)) {
        throw new Error(`Unsupported romanisation system: ${name}`);
    }
    return systems[name];
};

export default getPhoneticSystem;
